import React from 'react';
import '../styles/Footer.css';
import logo_futek from '../assets/futekfooterlogo.png'; // adjust path if needed
import akusense_logo from '../assets/akusense_logo.png'; // adjust path if needed
import post1 from '../assets/post1.jpg';
import post2 from '../assets/post2.jpg';
import { FaGreaterThan, FaPhone, FaPhoneAlt,FaEnvelope,FaInstagram  } from 'react-icons/fa';


import { FaFacebookF, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa6';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo and Contact */}
        <div className="footer-col">
          <img src={logo_futek} alt="FU-TEK Logo" className="footer-logo" /><br/>
          <img src={akusense_logo} alt="Akusense Logo" className="footer-logo2" />
          <p className="auth-badge">AUTHORISED PARTNER</p>
           

        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h2>Quick Links</h2>
          <ul>
            <li><a href='/PositionSensor'>➯ Position sensors</a></li>
            <li><a href='/ProcessFluidSensors'>➯ Process sensors / Fluid sensors</a></li>
            <li><a href='/AiImageRecognition'>➯ AI Image Recognition</a></li>
            <li><a href='/CodeReaderNew'>➯ Code Reader</a></li>
            <li><a href='/SafetySensor'>➯ Safety Sensor</a></li>
            <li><a href='/TestBox'>➯ Test Box</a></li>
          </ul>
        </div>

        {/* Latest Posts */}
        <div className="footer-col contact-col">
  <h2>Contact Us</h2>
  <ul className="contact-list">
    <li>
      <a href="tel:+917046062908" className="contact-link">
        <b><FaPhoneAlt /> +91 70460 62908</b>
      </a>
    </li>
    <li>
      <a href="mailto:sales@fu-tekautomation.co.in" className="contact-link">
        <b><FaEnvelope  /> sales@fu-tekautomation.co.in</b>
      </a>
    </li>
  </ul>

  <div className="contact-socials2">
    <a href="#"><FaFacebookF size={20} /></a>
    <a href="https://www.linkedin.com/in/fu-tek-automation-40316b1a7/"><FaLinkedinIn size={20} /></a>
    <a href="https://wa.me/917046062908"><FaWhatsapp size={20} /></a>
    <a href=""><FaInstagram /></a>
    
  </div>
</div>

      </div>
      <div className="footer-bottom">
        <p>© Copyright 2025 - Fu-Tek Automation All Rights Reserved. 
          {/* <br/>Design and Developed by <a>Romil Rana</a> */}
        </p>
      </div>
    </footer>
  );
};

export default Footer;